import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { API_URL } from "../../../config";

const AssignWarrantyModal = ({
  addWarrantyModal,
  setAddWarrantyModal,
  distributorId,
  setSuccessModal,
  setSuccessMessage,
  godevicelist,
}) => {
  const [warrantyQty, setWarrantyQty] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleAssignWarranty = async () => {
    setError("");

    if (!warrantyQty) {
      return setError("Please enter warranty quantity");
    }

    if (isNaN(warrantyQty) || Number(warrantyQty) <= 0) {
      return setError("Enter valid positive number");
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken");

      const res = await fetch(`${API_URL}/warranty-txn`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          distributor_id: distributorId,
          available: Number(warrantyQty),
        }),
      });

      const data = await res.json();

      if (!data.status) {
        throw new Error(data.message || "Something went wrong");
      }

      setWarrantyQty("");
      setAddWarrantyModal(false);
      setSuccessMessage("Warranty assigned successfully");
      godevicelist();
      setSuccessModal(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={addWarrantyModal}
      toggle={() => setAddWarrantyModal(false)}
      className="connect-box"
      centered={true}
    >
      <ModalHeader className="text-white" toggle={() => setAddWarrantyModal(false)}>
        <span className="ml-1 roititle text-white">Assign Warranty</span>
      </ModalHeader>

      <ModalBody>
        <div className="modal-paragrph">
          <div className="col-lg-12">
            <div className="row">
              <div className="form-group col-lg-12 no-padding">
                <label className="control-label mb-0">
                  Number of warranty*
                </label>

                <input
                  type="number"
                  value={warrantyQty}
                  onChange={(e) => setWarrantyQty(e.target.value)}
                  className="client-input"
                  placeholder="Enter warranty quantity"
                />

                {error && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {error}
                  </div>
                )}
              </div>
            </div>

            <div className="py-1 text-center" style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="button"
                onClick={handleAssignWarranty}
                className="btn-primary m-0"
                disabled={loading}
              >
                {loading ? "Assigning..." : "Assign"}
                {loading && <div id="loader"></div>}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AssignWarrantyModal;
